import { APIApartmentItemLikable } from 'api/types';
import { transformApartmentItem, transformTemporaryItem } from 'api/transformers';
import useApartmentsFilterQuery from './use-aparments-filter-query';
import { ApartmentListItemProps } from 'components/apartment-list-item';
import usePaginatedTemporaryData from './use-paginated-temporary';
import usePaginatedData from './use-paginated-data';

export type APIApartmentDealsRes = {
  items: APIApartmentItemLikable[];
  count: number;
};

export type ApartmentDeal = Omit<ApartmentListItemProps, 'className' | 'icon'> & { id: number };

const useApartmentTemporary = () => {
  const filter = useApartmentsFilterQuery();
  const result = usePaginatedData<any, ApartmentDeal>(
    '/temporary-files/list',
    'post',
    // @ts-ignore
    ({ items, count }) => {
      const apartments = items.map(transformApartmentItem);
      return { items: apartments, count };
    },
  );
  return result;
};

export default useApartmentTemporary;
